import { Link } from "react-router-dom";
import DocNavigation from "../../components/DocNavigation";

export default function QuickStart() {
    return (
        <section className="space-y-10">

            {/* HEADER */}
            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold text-slate-900 mb-2">
                    Quick Start
                </h1>
                <p className="text-md text-slate-600">
                    This guide gives you a quick but complete understanding of how EventFlow
                    is installed, configured, and made ready for real-world usage. It is
                    ideal for developers, system administrators, and technical partners
                    who want to understand the overall flow before diving into detailed steps.
                </p>
            </section>

            {/* OVERVIEW */}
            <section className="bg-white border-l border-[#C9A24E] p-8 rounded-lg">
                <h2 className="text-lg font-semibold mb-3">Overview</h2>
                <p className="text-slate-600 text-sm">
                    EventFlow is a Laravel-based banquet and event management system designed
                    for production environments. The installation approach follows industry
                    best practices where application logic remains secure while only required
                    public assets are exposed to the web.
                </p>
            </section>

            {/* WHO THIS IS FOR */}
            <section className="bg-slate-50 rounded-xl p-8">
                <h3 className="font-semibold mb-3">Who Should Use This Guide?</h3>
                <ul className="list-disc pl-5 space-y-2 text-slate-600">
                    <li>Developers deploying EventFlow on live servers</li>
                    <li>Hosting or IT teams responsible for setup</li>
                    <li>Agencies installing EventFlow for clients</li>
                    <li>Technical users performing self-deployment</li>
                </ul>
            </section>

            {/* WHAT YOU NEED */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-3">Before You Begin</h3>
                <ul className="list-disc pl-5 space-y-2 text-slate-600">
                    <li>A hosting server with PHP & MySQL support</li>
                    <li>Access to cPanel or hosting control panel</li>
                    <li>Basic understanding of Laravel directory structure</li>
                    <li>Database credentials (name, user, password)</li>
                </ul>
            </section>

            {/* INSTALLATION FLOW */}
            <section className="bg-slate-50 rounded-xl p-8">
                <h3 className="font-semibold mb-3">High-Level Installation Flow</h3>
                <ol className="list-decimal pl-5 space-y-2 text-slate-600">
                    <li>Upload Laravel project files to the server</li>
                    <li>Move public assets to <code className="bg-slate-200 px-2 py-1 rounded">public_html</code></li>
                    <li>Update application paths inside <code className="bg-slate-200 px-2 py-1 rounded">index.php</code></li>
                    <li>Configure environment variables in <code className="bg-slate-200 px-2 py-1 rounded">.env</code></li>
                    <li>Create and import the database</li>
                    <li>Verify installation and access the system</li>
                </ol>
            </section>

            {/* WHY THIS METHOD */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-3">Why This Deployment Method?</h3>
                <p className="text-slate-600">
                    This method keeps sensitive Laravel core files outside the public web
                    directory, reducing security risks and aligning with production-grade
                    deployment standards used by professional Laravel applications.
                </p>
            </section>

            {/* NEXT */}
            {/* <section className="border-t pt-8 mt-12">
                <p className="text-slate-600">
                    Next, follow the detailed step-by-step guide in{" "}
                    <Link to="/docs/installation" className="font-medium text-[#C9A24E]">
                        Installation
                    </Link>.
                </p>
            </section> */}
    <DocNavigation
                previous={{
                    title: "Who Is This For?",
                    link: "/docs/who-is-this-for"
                }}
                next={{
                    title: "Installation",
                    link: "/docs/installation"
                }}
            />
        </section>
    );
}
